import Axios from './index';
import { ListResult, HCCode } from '../Models';

export const getHCCodeList = async params => {
  const { data } = await Axios.get<ListResult<HCCode>>('/hccode', {
    params,
  });
  return data;
};

export const importHCCode = async (fd: FormData) => {
  const { data } = await Axios.post('/hccode/import', fd, {
    timeout: 1000 * 600,
  });
  return data;
};
